/**
 * © 2022 WavePlay <dev@waveplay.com>
 */
import type { DataMap } from '../_internal/types'

/**
 * Environment variables prefixed with `NEXT_PUBLIC_` are exposed to the app.
 * You can only access un-prefixed environment variables from the server.
 *
 * @see https://nextjs.org/docs/basic-features/environment-variables
 */
export const env: DataMap = {}
